import { Component } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-limit-reached-reward-status',
  standalone: true,
  imports: [FGBSharedModule],
  templateUrl: './limit-reached-reward-status.component.html',
  styleUrl: './limit-reached-reward-status.component.scss',
})
export class LimitReachedRewardStatusComponent {}
